import { render, staticRenderFns } from "./CredentialTable.vue?vue&type=template&id=4a880309&"
import script from "./CredentialTable.vue?vue&type=script&lang=js&"
export * from "./CredentialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports